import { createStore } from "vuex";
import auth from "./auth";
import nav from "./nav";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    nav,
  },
});
